<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align:center;">To Laura and Sarah.</p><br/>
<p style="text-align:center;">Thank you for the inspiration.</p><br/>
<p style="text-align:center;">And to every teenager navigating their way through life.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4ebf52ab